var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 8,
    height: 6,
    rx: 1,
    fill: "#303752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V3a2 2 0 1 0-4 0v2",
    stroke: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/input-icon.758d20581fafef6e11a4c20344f79ff0.svg";
export { ForwardRef as ReactComponent };